// Offline queue for Pocket Up — transactions saved locally, synced when back online
const QKEY = 'pocket_offline_queue';

export const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(QKEY) || '[]'); } catch { return []; }
};
export const setQueue = (q) => localStorage.setItem(QKEY, JSON.stringify(q));
export const pushQueue = (entry) => {
  const q = getQueue();
  q.push({ ...entry, queued_at: new Date().toISOString() });
  setQueue(q);
  return q.length;
};

export async function flushQueue(financeApi) {
  const q = getQueue();
  if (!q.length) return { sent: 0, remaining: 0 };
  const remaining = [];
  let sent = 0;
  for (const e of q) {
    try {
      if (e.kind === 'cheque') await financeApi.addCheque(e.payload);
      else await financeApi.addTransaction(e.payload);
      sent++;
    } catch (err) {
      // keep on network failure OR auth expiry (401) — drop only real server rejections
      if (!err?.response || err.response.status === 401) remaining.push(e);
    }
  }
  setQueue(remaining);
  return { sent, remaining: remaining.length };
}
